import { getNotificationState } from '../push';
import { useEffect }            from 'react';
import { useState }             from 'react';

const interval = 1000;

export default function useNotificationState() {
  const [ notificationState, setNotificationState ] = useState(null);

  async function getAndSetNotificationState() {
    setNotificationState(await getNotificationState());
  }

  useEffect(function() {
    if (notificationState === 'granted')
      return () => {};
    else {
      const intervalTimer = setInterval(getAndSetNotificationState, interval);
      return () => {
        clearInterval(intervalTimer);
      };
    }
  }, [ notificationState ]);

  return notificationState;
}
